/* eslint-disable @typescript-eslint/no-restricted-imports */
import {  QueryClient } from 'react-query'

export const queryClient = new QueryClient()